import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { NodeType, Node as documentNode} from "../../models/document/node";
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-row-item',
    templateUrl: './row-item.component.html',
    styleUrls: ['./row-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RowItemComponent implements OnInit, AfterViewInit {

  @Input()
  disabled: boolean = null;

  @Input()
  title: string = null;

  @Input()
  placement: string = null;

  @Input()
  spanTitle: string = null;

  @Input()
  subtitle: string = null;

  @Input()
  secondSubtitle: string = null;

  @Input()
  active: boolean = null;

  @Input()
  child: any;

  @Output() rowClick: EventEmitter<any> = new EventEmitter();

  faEllipsisV = faEllipsisV;

  @ViewChild('actionsWrapper') actionsWrapper: ElementRef;

  hasActions = false;

  NodeType = NodeType;

  updatedAt: Date;

  createdAt: Date;

  fileCount = 0;

  constructor() { }

  ngOnInit() {
    this.updatedAt = this.child?.document?.updatedAt;
    this.createdAt = this.child?.document?.createdAt;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.hasActions = Array.from(this.actionsWrapper.nativeElement.childNodes).filter((el: Node) => el.nodeName != '#comment').length > 0;
    });
  }

  countFilesFolder(node: documentNode): number | string {
    const fileCount = this.countFilesChild(node);

    if (fileCount > 0) {
      return fileCount === 1 ? '1 fichier' : `${fileCount} fichiers`;
    } else {
      return 'Aucun fichier';
    }
  }

  countFilesChild(node: documentNode): number {
    let fileNumber = 0;

    if (node.type === NodeType.FILE) {
      fileNumber++;
    } else if (node.type === NodeType.FOLDER && node.children) {
      for (const child of node.children) {
        fileNumber += this.countFilesChild(child);
      }
    }
    return fileNumber;
  }

  onRowClick(): void {
    this.rowClick.emit();
  }

}
